import { render, staticRenderFns } from "./TrainingBreadcrumbs.vue?vue&type=template&id=af50db6c&scoped=true"
import script from "./TrainingBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./TrainingBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af50db6c",
  null
  
)

export default component.exports